.dialog {
  width: min(680px, calc(100vw - 32px));
  max-height: min(760px, calc(100dvh - 32px));
  margin: auto;
  padding: 0;
  overflow: hidden;
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-overlay);
  background: var(--color-surface);
  color: var(--color-text-body);
  box-shadow: var(--shadow-overlay);
}

.dialog::backdrop {
  background: rgb(23 26 43 / 42%);
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-3);
  border-block-end: 1px solid var(--color-hairline);
}

.eyebrow {
  margin: 0 0 4px;
  color: var(--color-text-tertiary);
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.header h2 {
  margin: 0;
  color: var(--color-text-primary);
  font-size: 1.35rem;
}

.closeButton {
  display: inline-grid;
  place-items: center;
  min-width: var(--target-min);
  min-height: var(--target-min);
  padding: 0;
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-text-primary);
  cursor: pointer;
}

.closeButton:hover,
.secondaryButton:hover {
  border-color: var(--color-boundary);
  background: var(--color-surface-raised);
}

.form {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  margin: var(--space-2) var(--space-3) 0;
  padding-inline: var(--space-1);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface-raised);
  color: var(--color-text-secondary);
}

.form:focus-within {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.form input {
  flex: 1 1 auto;
  min-width: 0;
  min-height: var(--target-min);
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--color-text-primary);
  font: inherit;
}

.content {
  max-height: min(540px, calc(100dvh - 220px));
  padding: var(--space-2) var(--space-3) var(--space-3);
  overflow: auto;
}

.content h3 {
  margin: 0 0 var(--space-1);
  color: var(--color-text-secondary);
  font-size: 0.8125rem;
  font-weight: 750;
}

.list {
  display: grid;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.resultButton {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  width: 100%;
  min-height: 56px;
  padding: 10px var(--space-1);
  border: 1px solid transparent;
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--color-text-primary);
  font: inherit;
  text-align: start;
  cursor: pointer;
}

.resultButton:hover,
.resultButton:focus-visible {
  border-color: var(--color-hairline);
  background: var(--color-surface-raised);
}

.resultButton > span:last-child {
  flex: 0 0 auto;
  color: var(--color-accent);
  font-size: 1.25rem;
}

.resultCopy {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.resultCopy strong,
.resultCopy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resultCopy strong {
  color: var(--color-text-primary);
  font-weight: 750;
}

.resultCopy small {
  color: var(--color-text-secondary);
  font-size: 0.8125rem;
}

.status {
  margin: var(--space-2) 0;
  color: var(--color-text-secondary);
}

.error {
  display: grid;
  gap: var(--space-1);
  padding: var(--space-2);
  border: 1px solid var(--color-danger);
  border-radius: var(--radius-control);
  background: var(--color-danger-subtle);
  color: var(--color-danger);
}

.error p {
  margin: 0;
}

.secondaryButton {
  min-height: var(--target-min);
  padding-inline: var(--space-2);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-text-primary);
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

@media (max-width: 700px) {
  .dialog {
    inset: 0;
    width: 100vw;
    max-width: none;
    height: 100dvh;
    max-height: none;
    margin: 0;
    border: 0;
    border-radius: 0;
  }

  .header {
    padding-block-start: max(var(--space-2), env(safe-area-inset-top, 0px));
    padding-inline: max(var(--space-2), env(safe-area-inset-left, 0px)) max(var(--space-2), env(safe-area-inset-right, 0px));
  }

  .form,
  .content {
    margin-inline: max(var(--space-2), env(safe-area-inset-left, 0px)) max(var(--space-2), env(safe-area-inset-right, 0px));
  }

  .content {
    padding-inline: 0;
    padding-block-end: max(var(--space-3), env(safe-area-inset-bottom, 0px));
  }
}

@media (forced-colors: active) {
  .dialog,
  .form,
  .resultButton,
  .closeButton,
  .error {
    border: 2px solid CanvasText;
  }
}
